import { render, staticRenderFns } from "./DiggerLoader.vue?vue&type=template&id=0c98f3c4"
import script from "./DiggerLoader.vue?vue&type=script&lang=js"
export * from "./DiggerLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports